export default __webpack_public_path__ + "3d21985e01583b61fe4dd530e1c36a1c.png";